/**
 * @generated SignedSource<<9cfb12672fe6cd6a2f401ddb06805196>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UJStatuses = "OBSOLETE" | "PAUSED" | "RUNNING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type selfServiceStatus_statusFragment$data = {
  readonly id: string;
  readonly status: UJStatuses;
  readonly " $fragmentType": "selfServiceStatus_statusFragment";
};
export type selfServiceStatus_statusFragment$key = {
  readonly " $data"?: selfServiceStatus_statusFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"selfServiceStatus_statusFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "selfServiceStatus_statusFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "UserJourney",
  "abstractKey": null
};

(node as any).hash = "24d8b6666badae8c4cc89ad8d84da92f";

export default node;
